import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ResourceImageFormat } from './Enums'
/**
* Class ResourceImageInfoDto
*  Информация о файле-изображении
*/
export class ResourceImageInfoDto extends ActiveModel {

  /**
  * format
  * Формат изображения<br>  *   * - `png` PNG  *   * Изображение в формате PNG  * - `jpeg` JPEG  *   * Изображение в формате JPEG  * - `webp` WEBP  *   * Изображение в формате WEBP  * - `tiff` TIFF  *   * Изображение в формате TIFF  *   */
  @ActiveField(ResourceImageFormat.PNG)
  format: ResourceImageFormat = ResourceImageFormat.PNG


  /**
  * width
  * Ширина изображения<br>  */
  @ActiveField(0)
  width: number = 0


  /**
  * height
  * Высота изображения<br>  */
  @ActiveField(0)
  height: number = 0
}
